import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "sms-campaigns-footer" };
const _hoisted_2 = { class: "sms-campaigns-footer__buttons" };
const _hoisted_3 = ["src"];
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { mixpanelSmsCampaign } from '@/utilities/mixpanel/smsCampaigns';
import { createSmsCampaign } from '@/features/SMSCampaigns/data';
import { whatsappLink } from '@/features/SMSCampaigns/utils';
import i18n from '@/i18n';
import router from '@/router';
import ModalSmsTest from '@/features/SMSCampaigns/components/create/SMSCampaignsModalTest.vue';
import Alert from '@/components/_atoms/Alert.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SMSCampaignsFooter',
    setup(__props) {
        const { t } = i18n.global;
        const toast = useToast();
        const store = useStore();
        const loading = ref(false);
        const isVisibleModalSmsTest = ref(false);
        const showAlertInsufficientBalance = ref(false);
        const disableButton = computed(() => store.getters['smsCampaigns/isButtonDisabled']);
        const hasMessage = computed(() => store.getters['smsCampaigns/getMessage'].length);
        const balance = computed(() => store.state.smsCampaigns.balance);
        const openModalSMSTest = () => {
            if (!hasMessage.value) {
                store.commit('smsCampaigns/SET_HAS_INVALID_FIELDS', { key: 'message', value: true });
                return;
            }
            if (hasMessage.value && balance.value === 0) {
                showAlertInsufficientBalance.value = true;
                return;
            }
            isVisibleModalSmsTest.value = true;
        };
        const closeModalSMSTest = () => {
            isVisibleModalSmsTest.value = false;
        };
        const createCampaign = () => {
            loading.value = true;
            const campaign = store.state.smsCampaigns;
            const params = {
                campaignName: campaign.campaignName,
                audienceId: campaign.audience.id,
                sentDate: `${campaign.date} ${campaign.hour}`,
                message: campaign.message[0].message,
            };
            mixpanelSmsCampaign.create(params);
            createSmsCampaign(params)
                .then(isSuccessful => {
                if (isSuccessful) {
                    toast.success(t('sms-campaigns.footer.toast-create-success'), { timeout: 3000 });
                    setTimeout(() => {
                        router.push({ name: 'campaign-sms' });
                    }, 2000);
                    return;
                }
                toast.error(t('sms-campaigns.footer.toast-create-error'), { timeout: 3000 });
            })
                .catch(() => {
                toast.error(t('sms-campaigns.footer.toast-create-error'), { timeout: 3000 });
            })
                .finally(() => {
                loading.value = false;
            });
        };
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(ModalSmsTest, {
                    onCloseModal: closeModalSMSTest,
                    "is-visible": isVisibleModalSmsTest.value
                }, null, 8, ["is-visible"]),
                (showAlertInsufficientBalance.value)
                    ? (_openBlock(), _createBlock(Alert, {
                        key: 0,
                        onLinkClick: _cache[0] || (_cache[0] = ($event) => (_unref(mixpanelSmsCampaign).buySms('sms-test'))),
                        type: "error",
                        message: _ctx.$t('sms-campaigns.test-sms.alert-insufficient-balance', { link: _unref(whatsappLink) })
                    }, null, 8, ["message"]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_el_button, {
                        onClick: openModalSMSTest,
                        round: "",
                        class: "btn btn-outline-ctx-primary"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("img", {
                                src: require(`@/assets/svgs/Send.svg`)
                            }, null, 8, _hoisted_3),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('sms-campaigns.footer.button-send-sms-test')), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_el_button, {
                        onClick: createCampaign,
                        round: "",
                        loading: loading.value,
                        disabled: disableButton.value,
                        class: "btn btn-primary"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('sms-campaigns.footer.button')), 1)
                        ]),
                        _: 1
                    }, 8, ["loading", "disabled"])
                ])
            ]));
        };
    }
});
